import React from 'react';

import { Icon } from 'components/ui';
import { TYPES } from 'constants/config';
import Link from 'components/_shared/Link';
import CertificationBadge from 'components/CertificationBadge';
import ContentStatus from '../Content/Status';

const TypeIcon = ({ type, badge }) => {
  if (badge && badge.id) {
    return (
      <div className="mr-8 d-f">
        <CertificationBadge
          iconName={badge.iconName || badge.icon_name}
          width={22}
          height={29}
          foregroundColor={badge.foregroundColor || badge.foreground_color}
          backgroundColor={badge.backgroundColor || badge.background_color}
          image={badge.image || badge.image}
        />
      </div>
    );
  }
  if (type === TYPES.PATH) {
    return <Icon name="path" className="mr-8 fz-20 c-gray-dark f-sh-0" />;
  }

  if (type === TYPES.LESSON) {
    return <Icon name="lesson" className="mr-8 fz-20 c-gray-dark f-sh-0" />;
  }

  if (type === TYPES.DEMONSTRATION) {
    return <Icon name="link" className="mr-8 fz-20 c-gray-dark f-sh-0" />;
  }
  return null;
};

export default function CollapsedContentHeader(props) {
  const { type, urls = {}, title, description, badge } = props;
  const isPath = type === TYPES.PATH;

  return (
    <>
      <div className="d-f ai-c">
        {(type === TYPES.LESSON || isPath) && (
          <div className="PathContentCollapsed-header">
            <div className="d-f ai-c">
              <TypeIcon type={type} badge={badge} />
              <Link
                if={urls.view}
                href={urls.view}
                children={title}
                linkProps={{ className: 'ml-8 lh-1 fz-20 fw-b ff-ss f-smooth' }}
                className="mr-8 lh-1 fz-20 fw-b ff-ss f-smooth wb-bw"
              />
            </div>
            <div className="PathContentCollapsed-header-status">
              <ContentStatus {...props} />
            </div>
          </div>
        )}
        {type === TYPES.DEMONSTRATION && (
          <>
            <Icon name="link" className="fz-20 c-gray-dark f-sh-0" />
            <Link
              if={urls.view}
              href={urls.view}
              children={`${t('demonstrations.singular')}:&nbsp;${title}`}
              className="ml-8 lh-1 fz-20 fw-b ff-ss f-smooth"
            />
          </>
        )}
      </div>
      {!!description && (
        <p className="PathContentCollapsed-description mt-8 c-brand-gray-darkest f-smooth fz-16 ff-ss">
          {description}
        </p>
      )}
    </>
  );
}
